import { fork, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  LogControllerDtoMissionFreeLogListRequest,
  PerplayLogApi
} from '../../models/src';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import LogControllerDtoMissionFreeLogListResponse
  from '../../models/src/model/LogControllerDtoMissionFreeLogListResponse';
import { BASIC_MISSION_LOG_LIST_REQUEST } from '../../constants/log/basicMissionLogConstants';

const api = new PerplayLogApi(config.API_CLIENT);

function* basicMissionLogListRequestSaga(payload){
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData =  new LogControllerDtoMissionFreeLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.accountNo = payload.accountNo;
    requestData.missionIndex = payload.missionIndex;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayLogMissionFreeLogListPost({ logControllerDtoMissionFreeLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoMissionFreeLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* basicMissionLogRootSaga() {
  yield all([
    takeEvery(BASIC_MISSION_LOG_LIST_REQUEST, basicMissionLogListRequestSaga),
  ]);
}

const basicMissionLogSaga = [
  fork(basicMissionLogRootSaga)
];

export default basicMissionLogSaga;
